import { render } from "./EmailConfigurationWarning.vue?vue&type=template&id=d4e8dbf4&scoped=true"
import script from "./EmailConfigurationWarning.vue?vue&type=script&lang=js"
export * from "./EmailConfigurationWarning.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=d4e8dbf4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e8dbf4"]])

export default __exports__